import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansRepaymentSimulateComponent from './loansRepaymentSimulate.component';

let loansRepaymentSimulateModule = angular.module('loansRepaymentSimulate', [
  uiRouter
])

.component('loansRepaymentSimulate', loansRepaymentSimulateComponent)

.name;

export default loansRepaymentSimulateModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentSimulate/loansRepaymentSimulate.js